import MessageServices from "@services/MessageServices";
import UtilServices from "@services/UtilServices";

//Configurações das colunas do grid.
const getColumnFormat = (key, hiddenFields = []) => {
  // Se a chave estiver na lista de ocultação, retorna a configuração com visible: false
  if (hiddenFields.includes(key)) {
    return {
      dataField: key,
      visible: false, // Oculta a coluna
    };
  }

  // Se conter valor ele aplica a mascará
  if (key.toLowerCase().includes("valor")) {
    return {
      dataField: key,
      // width: 'auto',
      caption: key.charAt(0).toUpperCase() + key.slice(1),
      dataType: "number", // Define o tipo de dado como numérico
      format: "##0.00",
      alignment: "left",
    };
  }
  // Se for uma data válida, retorna o tipo de dado como 'date'
  else if (key.toLowerCase().includes("data")) {
    return {
      dataField: key,
      // width: 'auto',
      caption: key.charAt(0).toUpperCase() + key.slice(1),
      dataType: "date",
      format: "dd/MM/yyyy HH:mm:ss",
    };
    //Se a chave for exatamente "cpf", aplica a máscara
  } else if (key.toLowerCase().includes("cpf")) {
    return {
      dataField: key,
      // width: 'auto',
      caption: key.charAt(0).toUpperCase() + key.slice(1),
      customizeText: (cell) => UtilServices.maskCPF(cell.value),
    };
  }
  //Se a chave for exatamente "cnpj", aplica a máscara
  else if (key.toLowerCase().includes("cnpj")) {
    return {
      dataField: key,
      // width: 'auto',
      caption: key.charAt(0).toUpperCase() + key.slice(1),
      customizeText: (cell) => UtilServices.maskCNPJ(cell.value),
    };
  }
  // Caso contrário, pode retornar um tipo genérico
  else {
    return {
      dataField: key,
      // width: 'auto',
      caption: key.charAt(0).toUpperCase() + key.slice(1),
    };
  }
};
const setTooltip = (cssClass, icon, title) => {
  const link = document.createElement("a");
  link.href = "#";
  link.className = `dx-link ${cssClass} dx-icon ${icon} dx-link-icon`;
  link.setAttribute("data-tooltip-id", "tooltip-001");
  link.setAttribute("data-tooltip-content", title);
  // link.setAttribute("title", title);
  return link;
};

//Mapeamentos personalizados.
/*---RPA---*/
const getRPA_Regras = (
  data,
  handleDeletaRegra,
  handleConsultaRegraDetalhada,
) => {
  // Verifica se os dados são válidos
  const columns =
    data && data?.length > 0 && Object.keys(data[0])?.length > 0
      ? Object.keys(data[0]).map((key) => {
          return getColumnFormat(key, ["id_regra", "id_empresa"]);
        })
      : [
          // Default caso seja vazio.
          { dataField: "id", caption: "" },
        ];

  return [
    {
      caption: "Ações",
      type: "buttons",
      fixedPosition: "left",
      //fixed: true, //Estava quebrando o menuinterativo.
      width: 60,
      alignment: "center",
      buttons: [
        //Visualizar Regra
        {
          icon: "fa-solid fa-eye",
          alignment: "left",
          cssClass: "btn-editar",
          // disabled: function (e) {
          //     return !e.row.data?.exibirpdf;
          // },
          onClick: function (e) {
            handleConsultaRegraDetalhada(e.row.data?.id_regra);
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip("btn-editar", "fa-solid fa-eye", "Detalhes da regra"),
            );
          },
        },
        //Excluir Regras
        {
          icon: "fa-solid fa-xmark",
          alignment: "left",
          cssClass: "btn-excluir",
          //  visible: function () {
          //     return true;
          //  },
          onClick: function (e) {
            handleDeletaRegra(e.row.data?.id_regra);
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip("btn-excluir", "fa-solid fa-xmark", "Excluir Regra"),
            );
          },
        },
      ],
    },
    ...columns,
  ];
};
const getRPA_Analitico = (
  data,
  setShowModal,
  handleConsultaArquivoEFD,
  handleDownloadArquivoEFD,
  setShowModalB,
  setDel,
) => {
  // Verifica se os dados são válidos
  const columns =
    data && data?.length > 0 && Object.keys(data[0])?.length > 0
      ? Object.keys(data[0]).map((key) => {
          return getColumnFormat(key, [
            "icon",
            "id_empresa",
            "color",
            "exibirpdf",
            "id_compartilhado",
            "id_status",
            "id_automacao",
            "id_certificado",
            "id_dominio",
            "base64",
            "tipoarquivo",
            "statuscaixa",
            "base64txt",
            "exibirpdfbase64",
            "dt_alteracao",
            "Data Inicio",
            "Data Fim",
          ]);
        })
      : [
          // Default caso seja vazio.
          { dataField: "id", caption: "" },
        ];

  return [
    {
      caption: "Ações",
      type: "buttons",
      fixedPosition: "left",
      //fixed: true, //Estava quebrando o menuinterativo.
      width: "auto",
      alignment: "center",
      buttons: [
        //Download TXT
        {
          icon: "fa-solid fa-file-lines",
          alignment: "left",
          cssClass: "btn-editar",
          disabled: function (e) {
            return !e.row.data?.exibirpdfbase64;
          },
          onClick: function (e) {
            handleDownloadArquivoEFD({
              base64: e.row.data?.base64txt,
              tipoarquivo: "txt",
              id_automacao: e.row.data?.id_automacao,
              id_compartilhado: e.row.data?.id_compartilhado,
            });
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip(
                "btn-editar",
                "fa-solid fa-file-lines",
                "Download Arquivo .txt",
              ),
            );
          },
        },
        //Download PDF
        {
          icon: "fa-solid fa-file-arrow-down",
          alignment: "left",
          cssClass: "btn-editar",
          disabled: function (e) {
            return !e.row.data?.exibirpdf;
          },
          onClick: function (e) {
            handleDownloadArquivoEFD({
              base64: e.row.data?.base64,
              tipoarquivo: e.row.data?.tipoarquivo,
              id_automacao: e.row.data?.id_automacao,
              id_compartilhado: e.row.data?.id_compartilhado,
            });
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip(
                "btn-editar",
                "fa-solid fa-file-arrow-down",
                "Download PDF ou PNG",
              ),
            );
          },
        },
        //Visualizar PDF
        {
          icon: "fa-solid fa-eye",
          alignment: "left",
          cssClass: "btn-editar",
          disabled: function (e) {
            return !e.row.data?.exibirpdf;
          },
          onClick: function (e) {
            handleConsultaArquivoEFD({
              base64: e.row.data?.base64,
              tipoarquivo: e.row.data?.tipoarquivo,
              obs: e.row.data?.["Observações"],
              id_automacao: e.row.data?.id_automacao,
              id_compartilhado: e.row.data?.id_compartilhado,
            });
            setShowModal(true);
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip(
                "btn-editar",
                "fa-solid fa-eye",
                "Visualizar PDF ou PNG",
              ),
            );
          },
        },
        //Excluir
        {
          icon: "fa-solid fa-xmark",
          alignment: "left",
          cssClass: "btn-excluir",
          disabled: function (e) {
            if ([5].includes(e.row.data?.id_status)) {
              return true;
            }
            return false;
          },
          onClick: function (e) {
            setDel({
              id_automacao: e.row.data?.id_automacao,
              excluir: true,
              mensagem: `Deseja realmente excluir?<br/>
                                       Com essa exclusão, a empresa <br/> "${e.row.data["Razão Social"]}" <br/> <strong>será paralisada no robô.</strong>`,
            });
            setShowModalB(true);
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip("btn-excluir", "fa-solid fa-xmark", "Excluir"),
            );
          },
        },
        //Cancelar
        {
          icon: "fa-solid fa-ban",
          alignment: "left",
          cssClass: "btn-cancelar",
          disabled: function (e) {
            if ([3, 4, 7, 5].includes(e.row.data?.id_status)) {
              return true;
            }
            return false;
          },
          onClick: function (e) {
            setDel({
              id_automacao: e.row.data?.id_automacao,
              excluir: false,
              mensagem: `Deseja realmente cancelar?<br/>
                                       Com essa exclusão, a empresa <br/> "${e.row.data["Razão Social"]}" <br/> <strong>será paralisada no robô.</strong>`,
            });
            setShowModalB(true);
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip("btn-cancelar", "fa-solid fa-ban", "Cancelar"),
            );
          },
        },
      ],
    },
    ...columns,
  ];
};
const getRPA_Empresas = (data) => {
  // Verifica se os dados são válidos
  const columns =
    data && data?.length > 0 && Object.keys(data[0])?.length > 0
      ? Object.keys(data[0]).map((key) => {
          return getColumnFormat(key, [
            "obs",
            "id_regra",
            "id_empresa",
            "regime",
            "id_cliente",
            "dt_inclusao",
            "dt_inativacao",
            "id_certificado",
            "inscricaoestadual",
            "id_dominio",
            "base64txt",
            "exibirpdfbase64",
            "flg_dominio",
            "id_dodominio",
            "flg_ignoraraviso",
          ]);
        })
      : [
          // Default caso seja vazio.
          { dataField: "id", caption: "" },
        ];

  return [...columns];
};
const getRPA_EmpresasAgendadoresLog = (data) => {
  const colunasFixas = [
    getColumnFormat("CNPJ"),
    getColumnFormat("Status"),
    getColumnFormat("Razão Social"),
    getColumnFormat("Competência"),
  ];

  let columns;

  // Se tiver dados válidos
  if (
    Array.isArray(data) &&
    data.length > 0 &&
    Object.keys(data[0])?.length > 0
  ) {
    columns = Object.keys(data[0]).map((key) => {
      return getColumnFormat(key, ["id_status"]);
    });
  }
  if (columns) {
    return columns;
  }
  return colunasFixas;
};
const getRPA_EmpresasAgendadores = (data) => {
  const colunasFixas = [
    getColumnFormat("CNPJ"),
    getColumnFormat("Competência"),
    getColumnFormat("Razão Social"),
  ];

  let columns;

  // Se tiver dados válidos
  if (
    Array.isArray(data) &&
    data.length > 0 &&
    Object.keys(data[0])?.length > 0
  ) {
    columns = Object.keys(data[0]).map((key) => {
      return getColumnFormat(key, [
        "icon",
        "statuscaixa",
        "color",
        "Status",
        "Data Fim",
        "ExibirPDF",
        "id_status",
        "id_empresa",
        "Data Inicio",
        "Automação",
        "id_compartilhado",
        "id_automacao",
        "id_certificado",
        "id_dominio",
        // "ID Do Dominio",
        "Observações",
        "tipoarquivo",
        "exibirpdf",
        "base64",
        "dt_alteracao",
        "base64txt",
        "exibirpdfbase64",
      ]);
    });
  }
  if (columns) {
    return columns;
  }
  return colunasFixas;
};
/*---Cadastro RPA---*/
const getCadastroRPA_ImportacaoMassiva = (data) => {
  const colunasFixas = [
    getColumnFormat("status"),
    getColumnFormat("observacao"),
    getColumnFormat("filename"),
  ];

  let columns;

  // Se tiver dados válidos
  if (
    Array.isArray(data) &&
    data.length > 0 &&
    Object.keys(data[0])?.length > 0
  ) {
    columns = Object.keys(data[0]).map((key) => {
      return getColumnFormat(key, ["base64"]);
    });
  }
  if (columns) {
    return columns;
  }
  return colunasFixas;
};

/*---Partilha---*/
const getPartilha_log = (data) => {
  const colunasFixas = [
    getColumnFormat("Descricao"),
    getColumnFormat("Data Log"),
  ];

  let columns;

  // Se tiver dados válidos
  if (
    Array.isArray(data) &&
    data.length > 0 &&
    Object.keys(data[0])?.length > 0
  ) {
    columns = Object.keys(data[0]).map((key) => {
      return getColumnFormat(key, [
        "id_log",
        "usuario",
        "id_agrupador",
        "id_agendamento",
      ]);
    });
  }
  if (columns) {
    return columns;
  }
  return colunasFixas;
};

/*---Cliente---*/
const getCliente_Certificado = (data, setdel, setShowModal) => {
  const colunasFixas = [
    getColumnFormat("Certificado"),
    getColumnFormat("Data Vencimento"),
    getColumnFormat("Data Inclusão"),
  ];

  let columns;

  // Se tiver dados válidos
  if (
    Array.isArray(data) &&
    data.length > 0 &&
    Object.keys(data[0])?.length > 0
  ) {
    columns = Object.keys(data[0]).map((key) => {
      return getColumnFormat(key, [
        "id_cliente",
        "id_certificado",
        "dt_inativacao",
      ]);
    });
  }
  if (columns) {
    return [
      {
        caption: "Ações",
        type: "buttons",
        fixedPosition: "left",
        //fixed: true, //Estava quebrando o menuinterativo.
        width: 60,
        alignment: "center",
        buttons: [
          //Excluir
          {
            icon: "fa-solid fa-xmark",
            alignment: "left",
            cssClass: "btn-excluir",
            //  visible: function () {
            //     return true;
            //  },
            onClick: function (e) {
              setdel({
                id_certificado: e.row.data?.id_certificado,
                mensagem: `Deseja realmente excluir certificado?<br/>
                                            Com essa exclusão, as empresas vinculadas ao certificado <br/> "${e.row.data?.certificado}" <br/> <strong>serão paralisadas no robô.</strong>`,
              });
              setShowModal(true);
            },
            //Ativar o tooltip
            template: (container) => {
              // Adiciona o link no container
              container.appendChild(
                setTooltip(
                  "btn-excluir",
                  "fa-solid fa-xmark",
                  "Excluir Certificado",
                ),
              );
            },
          },
        ],
      },
      ...columns,
    ];
  }
  return colunasFixas;
};
const getCliente_LstDominio = (data, setdel, setShowModal) => {
  const colunasFixas = [
    getColumnFormat("Login Web"),
    getColumnFormat("Login Dominio"),
    getColumnFormat("Data Inclusão"),
  ];

  let columns;

  // Se tiver dados válidos
  if (
    Array.isArray(data) &&
    data.length > 0 &&
    Object.keys(data[0])?.length > 0
  ) {
    columns = Object.keys(data[0]).map((key) => {
      return getColumnFormat(key, [
        "id_cliente",
        "senha_web",
        "id_dominio",
        "senha_dominio",
        "dt_inativacao",
      ]);
    });
  }
  if (columns) {
    return [
      {
        caption: "Ações",
        type: "buttons",
        fixedPosition: "left",
        //fixed: true, //Estava quebrando o menuinterativo.
        width: 60,
        alignment: "center",
        buttons: [
          //Excluir
          {
            icon: "fa-solid fa-xmark",
            alignment: "left",
            cssClass: "btn-excluir",
            //  visible: function () {
            //     return true;
            //  },
            onClick: function (e) {
              setdel({
                id_dominio: e.row.data?.id_dominio,
                mensagem: `Deseja realmente excluir o dominio?<br/>
                                         Com essa exclusão, as empresas vinculadas <strong>serão paralisadas no robô.</strong>`,
              });
              setShowModal(true);
            },
            //Ativar o tooltip
            template: (container) => {
              // Adiciona o link no container
              container.appendChild(
                setTooltip(
                  "btn-excluir",
                  "fa-solid fa-xmark",
                  "Excluir Dominio",
                ),
              );
            },
          },
        ],
      },
      ...columns,
    ];
  }
  return colunasFixas;
};
const getCliente_Empresa = (data, setdel, setShowModal) => {
  const colunasFixas = [
    getColumnFormat("CNPJ"),
    getColumnFormat("Regime"),
    getColumnFormat("Observação"),
    getColumnFormat("Razão Social"),
    getColumnFormat("Data Inclusão"),
    getColumnFormat("Inscrição Estadual"),
  ];

  let columns;

  // Se tiver dados válidos
  if (
    Array.isArray(data) &&
    data.length > 0 &&
    Object.keys(data[0])?.length > 0
  ) {
    columns = Object.keys(data[0]).map((key) => {
      return getColumnFormat(key, [
        "id_cliente",
        "id_empresa",
        "id_certificado",
        "id_dominio",
        "dt_inativacao",
      ]);
    });
  }
  if (columns) {
    return [
      {
        caption: "Ações",
        type: "buttons",
        fixedPosition: "left",
        //fixed: true, //Estava quebrando o menuinterativo.
        width: 60,
        alignment: "center",
        buttons: [
          //Excluir
          {
            icon: "fa-solid fa-xmark",
            alignment: "left",
            cssClass: "btn-excluir",
            //  visible: function () {
            //     return true;
            //  },
            onClick: function (e) {
              setdel({
                id_empresa: e.row.data?.id_empresa,
                mensagem: `Deseja realmente excluir?<br/>
                                           Com essa exclusão, a empresa <br/> "${e.row.data["Razão Social"]}" <br/> <strong>será paralisada no robô.</strong>`,
              });
              setShowModal(true);
            },
            //Ativar o tooltip
            template: (container) => {
              // Adiciona o link no container
              container.appendChild(
                setTooltip(
                  "btn-excluir",
                  "fa-solid fa-xmark",
                  "Excluir/Inativar Empresa",
                ),
              );
            },
          },
        ],
      },
      ...columns,
    ];
  }
  return colunasFixas;
};

/*---ReceitaBX---*/
const getRPA_EmpresasReceitaBX = (data) => {
  const colunasFixas = [
    getColumnFormat("CNPJ"),
    getColumnFormat("Razão Social"),
  ];

  let columns;

  // Se tiver dados válidos
  if (
    Array.isArray(data) &&
    data.length > 0 &&
    Object.keys(data[0])?.length > 0
  ) {
    columns = Object.keys(data[0]).map((key) => {
      return getColumnFormat(key, ["id_empresa"]);
    });
  }
  if (columns) {
    return [...columns];
  }
  return colunasFixas;
};
const getRPA_ConsultaReceitaBX = (data, setShowModalB, setDel) => {
  // Verifica se os dados são válidos
  const columns =
    data && data?.length > 0 && Object.keys(data[0])?.length > 0
      ? Object.keys(data[0]).map((key) => {
          return getColumnFormat(key, [
            "icon",
            "id_empresa",
            "color",
            "exibirpdf",
            "id_compartilhado",
            "id_status",
            "id_automacao",
            "id_certificado",
            "id_dominio",
            "base64",
            "tipoarquivo",
            "statuscaixa",
            "base64txt",
            "exibirpdfbase64",
            "dt_alteracao",
            "Competência",
            "ID Do Dominio",
          ]);
        })
      : [
          // Default caso seja vazio.
          { dataField: "id", caption: "" },
        ];

  return [
    {
      caption: "Ações",
      type: "buttons",
      fixedPosition: "left",
      //fixed: true, //Estava quebrando o menuinterativo.
      width: "auto",
      alignment: "center",
      buttons: [
        //Excluir
        {
          icon: "fa-solid fa-xmark",
          alignment: "left",
          cssClass: "btn-excluir",
          disabled: function (e) {
            if ([5].includes(e.row.data?.id_status)) {
              return true;
            }
            return false;
          },
          onClick: function (e) {
            setDel({
              id_automacao: e.row.data?.id_automacao,
              excluir: true,
              mensagem: `Deseja realmente excluir?<br/>
                                       Com essa exclusão, a empresa <br/> "${e.row.data["Razão Social"]}" <br/> <strong>será paralisada no robô.</strong>`,
            });
            setShowModalB(true);
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip("btn-excluir", "fa-solid fa-xmark", "Excluir"),
            );
          },
        },
        //Cancelar
        {
          icon: "fa-solid fa-ban",
          alignment: "left",
          cssClass: "btn-cancelar",
          disabled: function (e) {
            if ([3, 4, 7, 5].includes(e.row.data?.id_status)) {
              return true;
            }
            return false;
          },
          onClick: function (e) {
            setDel({
              id_automacao: e.row.data?.id_automacao,
              excluir: false,
              mensagem: `Deseja realmente cancelar?<br/>
                                       Com essa exclusão, a empresa <br/> "${e.row.data["Razão Social"]}" <br/> <strong>será paralisada no robô.</strong>`,
            });
            setShowModalB(true);
          },
          //Ativar o tooltip
          template: (container) => {
            // Adiciona o link no container
            container.appendChild(
              setTooltip("btn-cancelar", "fa-solid fa-ban", "Cancelar"),
            );
          },
        },
      ],
    },
    ...columns,
  ];
};

export default {
  /*---RPA---*/
  getRPA_Regras(
    data,
    handleDeletaRegra,
    handleConsultaRegraDetalhada,
    dispatch,
  ) {
    return getRPA_Regras(
      data,
      handleDeletaRegra,
      handleConsultaRegraDetalhada,
      dispatch,
    );
  },
  getRPA_Analitico(
    data,
    setShowModal,
    handleConsultaArquivoEFD,
    handleDownloadArquivoEFD,
    setShowModalB,
    setDel,
  ) {
    return getRPA_Analitico(
      data,
      setShowModal,
      handleConsultaArquivoEFD,
      handleDownloadArquivoEFD,
      setShowModalB,
      setDel,
    );
  },
  getRPA_Empresas(data) {
    return getRPA_Empresas(data);
  },
  getRPA_EmpresasAgendadores(data) {
    return getRPA_EmpresasAgendadores(data);
  },
  getRPA_EmpresasAgendadoresLog(data) {
    return getRPA_EmpresasAgendadoresLog(data);
  },
  /*---Cadastro RPA---*/
  getCadastroRPA_ImportacaoMassiva(data) {
    return getCadastroRPA_ImportacaoMassiva(data);
  },

  /*---Partilha---*/
  getPartilha_log(data) {
    return getPartilha_log(data);
  },

  /*---Cliente---*/
  getCliente_Certificado(data, setdel, setShowModal) {
    return getCliente_Certificado(data, setdel, setShowModal);
  },
  getCliente_LstDominio(data, setdel, setShowModal) {
    return getCliente_LstDominio(data, setdel, setShowModal);
  },
  getCliente_Empresa(data, setdel, setShowModal) {
    return getCliente_Empresa(data, setdel, setShowModal);
  },

  /*---ReceitaBX---*/
  getRPA_EmpresasReceitaBX(data) {
    return getRPA_EmpresasReceitaBX(data);
  },
  getRPA_ConsultaReceitaBX(data, setShowModalB, setDel) {
    return getRPA_ConsultaReceitaBX(data, setShowModalB, setDel);
  },
};
